/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface RequestLoginCodeBody
 */
export interface RequestLoginCodeBody {
    /**
     * 
     * @type {string}
     * @memberof RequestLoginCodeBody
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof RequestLoginCodeBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * Optional challenge slug. When provided, the challenge's emailConfig.loginCodeEmailTemplateId is used for the verification code email instead of the platform default.
     * @type {string}
     * @memberof RequestLoginCodeBody
     */
    challengeSlug?: string;
    /**
     * Optional Drop slug. When provided and the Drop carries an onboarding experience, that experience's emailConfig.loginCodeEmailTemplateId brands the code email. Explicit slug only — never inferred.
     * @type {string}
     * @memberof RequestLoginCodeBody
     */
    dropSlug?: string;
}

/**
 * Check if a given object implements the RequestLoginCodeBody interface.
 */
export function instanceOfRequestLoginCodeBody(value: object): value is RequestLoginCodeBody {
    return true;
}

export function RequestLoginCodeBodyFromJSON(json: any): RequestLoginCodeBody {
    return RequestLoginCodeBodyFromJSONTyped(json, false);
}

export function RequestLoginCodeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLoginCodeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'challengeSlug': json['challengeSlug'] == null ? undefined : json['challengeSlug'],
        'dropSlug': json['dropSlug'] == null ? undefined : json['dropSlug'],
    };
}

export function RequestLoginCodeBodyToJSON(json: any): RequestLoginCodeBody {
    return RequestLoginCodeBodyToJSONTyped(json, false);
}

export function RequestLoginCodeBodyToJSONTyped(value?: RequestLoginCodeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'challengeSlug': value['challengeSlug'],
        'dropSlug': value['dropSlug'],
    };
}

